import React, {createContext, useState} from "react";

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {

    const [tourSettings, setTourSettings] = useState(null);

    return (
        <SettingsContext.Provider value={{ tourSettings, setTourSettings }}>
            {children}
        </SettingsContext.Provider>
    );

}
